import React, {Fragment, useState} from 'react';
import logo from '../assets/img/logo_compra_pyme.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import '../assets/css/Navbar.scss';

const Navbar = () => {

  const [open, setOpen] = useState(false);

  const openMenu = () => {
    setOpen(!open);
  };

  return (
    <Fragment>

      <nav className="navbar navbar-expand-lg navbar-light navbar-p-5-perc">
        <a href="/">
          <img src={logo} className="logo-navbar" alt="logo"/>
        </a>

        <button className="transparent-btn" onClick={() => openMenu()}>
          <span className="navbar-toggler-icon hover-icon"></span>
        </button>

        <div className="navbar-collapse collapse w-100 order-3 dual-collapse2" id="navbarTogglerDemo02">
            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <a className="nav-link menu_custom" href="/sobre_compra_pyme.html">Sobre Compra Pyme</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link menu_custom" href="/talleres/">Talleres</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link menu_custom" href="mailto:comprapyme@economia.cl">Contáctanos</a>
                </li>
                {(true && <li className="nav-item ml-2 d-flex align-items-center">
                    <a className="boton_custom btn btn-warning btn-lg" target="_blank" rel="noopener noreferrer" href="/inscripcion/index.html">Inscríbete ahora</a>
                </li>)}
            </ul>
        </div>
      </nav>

      <div className={`menu-floating ${open ? 'display-menu' : 'hidden'}`}>
        <div className="row p-5-perc">

          <div className="right-items">
            <button className="transparent-btn" onClick={() => openMenu()}>
              <FontAwesomeIcon icon={faTimes} className="fa-times-x"/>
            </button>
          </div>

          <div className="col-md-12 m-t-30-npr">

            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <a className="nav-link menu_custom_light" href="/sobre_compra_pyme.html">Sobre Compra Pyme</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link menu_custom" href="/talleres/">Talleres</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link menu_custom_light" href="mailto:comprapyme@economia.cl">Contáctanos</a>
                </li>
                {(true && <li className="nav-item">
                    <a className="nav-link menu_custom_light" href="/inscripcion/index.html">Inscríbete ahora</a>
                </li>)}
            </ul>

          </div>

        </div>
      </div>

    </Fragment>
  )
};

export default Navbar;
